import { render, staticRenderFns } from "./addProductLabel.vue?vue&type=template&id=f25a54e6"
import script from "./addProductLabel.vue?vue&type=script&lang=js"
export * from "./addProductLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports